module.exports = __webpack_public_path__ + "img/ticino03.e110948d.jpg";